export default {
    "title": "Press",
    "entityName": "press",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    filterStorage: {},
    "fields": [{
            full: true,
            "value": "type",
            "text": "Tipo",
            "type": "list",
            "list": ['Banner', 'Banner Generator', 'Comunicati', 'Dicono di noi', 'Focus on', 'Intervista'],
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
        },

        // {
        //     full: true,
        //     "value": "author",
        //     "text": "Autore",
        //     "type": "text",
        //     "table": {
        //         "sortable": true,
        //         "filter": true
        //     },
        //     "validators": [
        //         "required"
        //     ],
        // },

        {
            full: true,
            "value": "title",
            "text": "Titolo",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
        },

        {
            "value": "department_id",
            "text": "Reparto",
            "title": "name",
            "id": "department_id",
            "type": "autocomplete",
            // "readonly": item => { return item.id ? true : false },
            // "return_object": true,
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
            ],
            // render: (item) => {
            //     return item.country.name + " (" + item.country.code + ")" 
            // },
        },


        {
            full: true,
            "value": "public",
            "text": "Public",
            "type": "check",
            "table": {
                "sortable": true,
                "filter": true
            },
        },

        // {
        //     full: true,
        //     "value": "in_homepage",
        //     "text": "Homepage",
        //     "type": "check",
        //     "table": {
        //         "sortable": true,
        //         "filter": true
        //     },
        // },
        

        // {
        //     full: true,
        //     "value": "in_carousel",
        //     "text": "Carousel",
        //     "type": "check",
        //     "table": {
        //         "sortable": true,
        //         "filter": true
        //     },
        // },


        // {
        //     full: true,
        //     "value": "in_mediacenter",
        //     "text": "Mediacenter",
        //     "type": "check",
        //     "table": {
        //         "sortable": true,
        //         "filter": true
        //     },
        // },




    ],
    "actions": [
        {
            "value": "link",
            "text": "Open press",
            "icon": "mdi-link",
            "color": "primary",
            disable: (item) => item.type != "Focus on" && item.type != "Intervista"
        },
        {
            "value": "update",
            "text": "Edit",
            "icon": "mdi-pencil",
            "color": "primary",
        }, 
        "delete"
    ]
}